(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar() {
    var raiz = document.querySelector('[data-pmc]');
    if (!raiz || raiz.dataset.pmcOk === '1') return;
    raiz.dataset.pmcOk = '1';

    var sectionId = raiz.getAttribute('data-section-id');
    var bloqueado = false;

    function actualizarBurbuja(n) {
      document.querySelectorAll('[data-pah-count], [data-pa-contador]').forEach(function (el) { el.textContent = n; });
    }

    var PARTES = ['[data-pmc-cabnum]', '[data-pmc-envio]', '[data-pmc-items]', '[data-pmc-resumen-dyn]'];

    function repintar(cart) {
      if (cart && typeof cart.item_count !== 'undefined') actualizarBurbuja(cart.item_count);

      // si el carrito queda vacio, recargamos para mostrar el estado vacio y que la app se reinicie
      if (cart && cart.item_count === 0) { window.location.reload(); return; }

      if (cart && cart.sections && cart.sections[sectionId]) {
        var doc = new DOMParser().parseFromString(cart.sections[sectionId], 'text/html');
        // Actualizamos SOLO las partes dinamicas, sin tocar el formulario de checkout.
        PARTES.forEach(function (sel) {
          var nuevo = doc.querySelector(sel);
          var actual = raiz.querySelector(sel);
          if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
          else if (actual && !nuevo) actual.innerHTML = '';
        });
      }
      document.dispatchEvent(new CustomEvent('ponteaura:carrito', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      bloqueado = false;
    }

    function cambiar(linea, cantidad) {
      if (bloqueado) return;
      bloqueado = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: linea, quantity: cantidad, sections: [sectionId], sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(repintar).catch(function () { bloqueado = false; });
    }

    function agregar(id) {
      if (bloqueado) return;
      bloqueado = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: [sectionId], sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      }).then(repintar).catch(function () { bloqueado = false; });
    }

    raiz.addEventListener('click', function (e) {
      var qty = e.target.closest('[data-pmc-qty]');
      if (qty) {
        var linea = parseInt(qty.getAttribute('data-line'), 10);
        var delta = parseInt(qty.getAttribute('data-delta'), 10);
        var input = raiz.querySelector('.pmc__qty[data-line="' + linea + '"]');
        var actual = input ? (parseInt(input.value, 10) || 1) : 1;
        cambiar(linea, Math.max(0, actual + delta));
        return;
      }
      var rm = e.target.closest('[data-pmc-remove]');
      if (rm) { cambiar(parseInt(rm.getAttribute('data-line'), 10), 0); return; }

      var add = e.target.closest('[data-pmc-add]');
      if (add && !add.disabled) { agregar(add.getAttribute('data-pmc-add')); return; }

      var cuponT = e.target.closest('[data-pmc-cupon-toggle]');
      if (cuponT) { var c = raiz.querySelector('[data-pmc-cupon]'); if (c) c.hidden = !c.hidden; return; }

      var cuponOk = e.target.closest('[data-pmc-cupon-ok]');
      if (cuponOk) {
        var inp = raiz.querySelector('[data-pmc-cupon-input]');
        var codigo = inp ? inp.value.trim() : '';
        if (codigo) window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
        return;
      }
    });

    raiz.addEventListener('change', function (e) {
      var input = e.target.closest('[data-pmc-qty-input]');
      if (!input) return;
      var linea = parseInt(input.getAttribute('data-line'), 10);
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 1;
      cambiar(linea, val);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-cabecera-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function iniciar(scope) {
    var raiz = scope && scope.querySelector ? scope.querySelector('[data-pah]') : null;
    if (!raiz) raiz = document.querySelector('[data-pah]:not([data-pah-listo])');
    if (!raiz) return;

    var id = raiz.getAttribute('data-seccion') || 'pah';
    if (raiz.getAttribute('data-pah-listo') === id) return;
    raiz.setAttribute('data-pah-listo', id);

    /* Evita que wrappers del tema corten overlays/fixed. */
    if (raiz.parentNode !== document.body) document.body.appendChild(raiz);

    var top = raiz.querySelector('[data-pah-top]');
    var bar = raiz.querySelector('[data-pah-bar]');
    var anuncio = raiz.querySelector('[data-pah-anuncio]');
    var scrim = raiz.querySelector('[data-pah-scrim]');
    var drawer = raiz.querySelector('[data-pah-drawer]');
    var burger = raiz.querySelector('[data-pah-burger]');
    var drawerClose = raiz.querySelector('[data-pah-drawer-close]');
    var search = raiz.querySelector('[data-pah-search]');
    var searchInput = search ? search.querySelector('[data-pah-search-input]') : null;
    var predictive = search ? search.querySelector('[data-pah-predictive]') : null;
    var searchDefault = search ? search.querySelector('[data-pah-search-default]') : null;
    var scrollThreshold = parseInt(raiz.getAttribute('data-scroll-umbral') || '24', 10);
    var lastFocus = null;
    var lockCount = 0;
    var originalBodyOverflow = document.body.style.overflow;


    /* Oculta header original, sin tocar este header. */
    var ocultarTema = raiz.getAttribute('data-ocultar-tema') === 'true';
    var selectorTema = (raiz.getAttribute('data-selector-tema') || '').trim();
    if (ocultarTema) {
      var selectors = selectorTema ? [selectorTema, 'header-component'] : ['header-component'];
      selectors.forEach(function (selector) {
        try {
          document.querySelectorAll(selector).forEach(function (node) {
            if (raiz.contains(node)) return;
            var target = node.closest('.shopify-section') || node;
            if (!target || target === raiz || raiz.contains(target)) return;
            if (!target.hasAttribute('data-pah-display')) target.setAttribute('data-pah-display', target.style.display || '');
            target.style.display = 'none';
          });
        } catch (e) {}
      });
    }

    /* Reserva el alto inicial del header sin saltos al compactarse. */
    var initialOffset = 0;
    var baseBodyPadding = parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
    function medirOffset(force) {
      var h = (bar ? bar.offsetHeight : 0) + (anuncio ? anuncio.scrollHeight : 0);
      if (force || h > initialOffset) initialOffset = h;
      document.body.style.paddingTop = (baseBodyPadding + initialOffset) + 'px';
      var stickyH = (anuncio ? anuncio.offsetHeight : 0) + (bar ? bar.offsetHeight : 0) + 16;
      document.documentElement.style.scrollPaddingTop = Math.max(80, stickyH) + 'px';
    }
    medirOffset(true);
    window.addEventListener('load', function () { medirOffset(true); }, { once: true });
    window.addEventListener('resize', function () { medirOffset(false); }, { passive: true });

    /*
      Estado de scroll robusto.
      En algunos themes de Shopify desktop el documento visible se desplaza dentro de un wrapper,
      mientras en mobile el scroll ocurre sobre window. Escuchamos ambos casos para que el glass
      se active exactamente igual en computador y celular.
    */
    var scrollState = null;
    var ticking = false;
    var lastScrollSource = null;

    function documentScrollY() {
      return Math.max(
        window.pageYOffset || 0,
        window.scrollY || 0,
        document.documentElement ? (document.documentElement.scrollTop || 0) : 0,
        document.body ? (document.body.scrollTop || 0) : 0
      );
    }

    function sourceScrollY(source) {
      if (!source || source === window || source === document || source === document.documentElement || source === document.body) return 0;
      if (typeof source.scrollTop !== 'number') return 0;
      /* Ignora pequeños paneles internos: solo un contenedor grande puede gobernar el header. */
      var h = source.clientHeight || 0;
      if (h && h < window.innerHeight * 0.58) return 0;
      return source.scrollTop || 0;
    }

    function setScrollState(active) {
      if (active === scrollState) return;
      scrollState = active;
      if (top) top.classList.toggle('pah__top--scroll', active);
    }

    function onScrollFrame() {
      var y = Math.max(documentScrollY(), sourceScrollY(lastScrollSource));
      setScrollState(y > scrollThreshold);
      ticking = false;
    }

    function queueScroll(source) {
      lastScrollSource = source || lastScrollSource;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScrollFrame);
    }

    window.addEventListener('scroll', function () { queueScroll(window); }, { passive: true });
    document.addEventListener('scroll', function (e) { queueScroll(e.target); }, { passive: true, capture: true });

    /* IntersectionObserver sirve como respaldo para layouts con scroll no convencional. */
    var sentinel = document.createElement('span');
    sentinel.setAttribute('data-pah-scroll-sentinel', '');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;opacity:0;';
    document.body.insertBefore(sentinel, document.body.firstChild);
    if ('IntersectionObserver' in window) {
      try {
        new IntersectionObserver(function (entries) {
          if (!entries || !entries.length) return;
          if (!entries[0].isIntersecting) setScrollState(true);
          else if (documentScrollY() <= scrollThreshold) setScrollState(false);
        }, { threshold: 0 }).observe(sentinel);
      } catch (e) {}
    }

    onScrollFrame();

    function lockBody() {
      lockCount += 1;
      if (lockCount === 1) document.body.style.overflow = 'hidden';
    }
    function unlockBody() {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) document.body.style.overflow = originalBodyOverflow;
    }

    function focusables(container) {
      if (!container) return [];
      return Array.prototype.slice.call(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function trapFocus(e, container) {
      if (e.key !== 'Tab') return;
      var list = focusables(container);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* Mega menú: hover, click y teclado. */
    var items = raiz.querySelectorAll('[data-pah-item][data-mega]');
    var megas = raiz.querySelectorAll('[data-pah-mega]');
    var megaTimer = null;
    function cerrarMega() {
      window.clearTimeout(megaTimer);
      megas.forEach(function (m) { m.classList.remove('pah__mega--abierto'); });
      raiz.querySelectorAll('[data-pah-item]').forEach(function (item) {
        item.classList.remove('pah__navitem--activo');
        var link = item.querySelector('.pah__navlink');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
      if (top) top.classList.remove('pah__top--frente');
      if (scrim && !(drawer && drawer.classList.contains('pah__drawer--abierto'))) {
        scrim.classList.remove('pah__scrim--visible', 'pah__scrim--frente');
      }
    }
    function abrirMega(mid, item) {
      window.clearTimeout(megaTimer);
      megas.forEach(function (m) { m.classList.toggle('pah__mega--abierto', m.getAttribute('data-pah-mega') === mid); });
      raiz.querySelectorAll('[data-pah-item]').forEach(function (x) { x.classList.remove('pah__navitem--activo'); });
      if (item) {
        item.classList.add('pah__navitem--activo');
        var link = item.querySelector('.pah__navlink');
        if (link) link.setAttribute('aria-expanded', 'true');
      }
      if (top) top.classList.add('pah__top--frente');
      if (scrim) {
        scrim.classList.remove('pah__scrim--drawer');
        scrim.classList.add('pah__scrim--visible', 'pah__scrim--frente');
      }
    }
    items.forEach(function (item) {
      var mid = item.getAttribute('data-mega');
      var link = item.querySelector('.pah__navlink');
      if (link) link.setAttribute('aria-expanded', 'false');
      item.addEventListener('mouseenter', function () { abrirMega(mid, item); });
      item.addEventListener('mouseleave', function () { megaTimer = window.setTimeout(cerrarMega, 130); });
      item.addEventListener('focusin', function () { abrirMega(mid, item); });
      if (link) {
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            abrirMega(mid, item);
            var panel = raiz.querySelector('[data-pah-mega="' + mid + '"]');
            var first = panel && panel.querySelector('a');
            if (first) first.focus();
          }
        });
      }
    });
    megas.forEach(function (mega) {
      mega.addEventListener('mouseenter', function () { window.clearTimeout(megaTimer); });
      mega.addEventListener('mouseleave', function () { megaTimer = window.setTimeout(cerrarMega, 130); });
    });

    /* Drawer móvil. */
    function abrirDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      cerrarMega();
      drawer.classList.add('pah__drawer--abierto');
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('pah__scrim--drawer', 'pah__scrim--visible');
      lockBody();
      window.setTimeout(function () { if (drawerClose) drawerClose.focus(); }, 80);
    }
    function cerrarDrawer(restoreFocus) {
      if (!drawer || !drawer.classList.contains('pah__drawer--abierto')) return;
      drawer.classList.remove('pah__drawer--abierto');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.classList.remove('pah__scrim--drawer', 'pah__scrim--visible');
      unlockBody();
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (burger) burger.addEventListener('click', abrirDrawer);
    if (drawerClose) drawerClose.addEventListener('click', function () { cerrarDrawer(true); });

    /* Acordeones accesibles. */
    raiz.querySelectorAll('[data-acc-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var acc = toggle.closest('[data-acc]');
        if (!acc) return;
        var next = !acc.classList.contains('is-open');
        acc.classList.toggle('is-open', next);
        toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
      });
    });

    /* Search + búsquedas recientes + predictive search. */
    var RECENT_KEY = 'ponteaura_busquedas_v2';
    var debounceTimer = null;
    var suggestAbort = null;

    function getRecents() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
    }
    function guardarReciente(value) {
      var q = (value || '').trim();
      if (!q) return;
      var list = getRecents().filter(function (x) { return String(x).toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
    }
    function pintarRecientes() {
      var block = search ? search.querySelector('[data-pah-recent-block]') : null;
      var holder = search ? search.querySelector('[data-pah-recent]') : null;
      if (!block || !holder) return;
      var list = getRecents();
      block.hidden = !list.length;
      holder.innerHTML = list.map(function (x) {
        return '<a class="pah__chip" href="/search?type=product&q=' + encodeURIComponent(x) + '">' + esc(x) + '</a>';
      }).join('');
    }
    function formatMoney(cents) {
      var value = Number(cents || 0) / 100;
      try { return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(value); }
      catch (e) { return '$' + Math.round(value).toLocaleString('es-CO'); }
    }
    function renderPredictive(query, products) {
      if (!predictive || !searchDefault) return;
      predictive.hidden = false;
      searchDefault.hidden = true;
      if (!products || !products.length) {
        predictive.innerHTML = '<div class="pah__predictive-head"><span class="pah__predictive-title">Resultados</span></div><div class="pah__predictive-empty">No encontramos productos para “' + esc(query) + '”. Prueba con una marca, perfume o decant.</div>';
        return;
      }
      var cards = products.map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var vendor = p.vendor || '';
        var price = typeof p.price === 'number' ? formatMoney(p.price) : (p.price || '');
        return '<a class="pah__predictive-card" href="' + esc(p.url || '#') + '">' +
          '<span class="pah__predictive-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="pah__predictive-meta">' + (vendor ? '<span class="pah__predictive-vendor">' + esc(vendor) + '</span>' : '') +
          '<span class="pah__predictive-name">' + esc(p.title || '') + '</span>' + (price ? '<span class="pah__predictive-price">' + esc(price) + '</span>' : '') + '</span></a>';
      }).join('');
      predictive.innerHTML = '<div class="pah__predictive-head"><span class="pah__predictive-title">Resultados para “' + esc(query) + '”</span><a class="pah__predictive-view" href="/search?type=product&q=' + encodeURIComponent(query) + '">Ver todos</a></div><div class="pah__predictive-grid">' + cards + '</div>';
    }
    function resetPredictive() {
      if (suggestAbort) { try { suggestAbort.abort(); } catch (e) {} suggestAbort = null; }
      if (predictive) { predictive.hidden = true; predictive.innerHTML = ''; }
      if (searchDefault) searchDefault.hidden = false;
    }
    function buscarPredictivo(value) {
      var q = (value || '').trim();
      window.clearTimeout(debounceTimer);
      if (q.length < 2) { resetPredictive(); return; }
      debounceTimer = window.setTimeout(function () {
        if (!predictive || !searchDefault) return;
        predictive.hidden = false;
        searchDefault.hidden = true;
        predictive.innerHTML = '<div class="pah__predictive-loading">Buscando…</div>';
        if (suggestAbort) { try { suggestAbort.abort(); } catch (e) {} }
        suggestAbort = 'AbortController' in window ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' }, signal: suggestAbort ? suggestAbort.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error('search'); return r.json(); })
          .then(function (data) {
            var products = data && data.resources && data.resources.results ? data.resources.results.products : [];
            renderPredictive(q, products || []);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            resetPredictive();
          });
      }, 220);
    }
    function abrirSearch() {
      if (!search) return;
      var opener = document.activeElement;
      if (drawer && drawer.classList.contains('pah__drawer--abierto')) {
        cerrarDrawer(false);
        lastFocus = burger || opener;
      } else {
        lastFocus = opener;
      }
      pintarRecientes();
      resetPredictive();
      search.classList.add('pah__search--abierto');
      search.setAttribute('aria-hidden', 'false');
      lockBody();
      window.setTimeout(function () { if (searchInput) searchInput.focus(); }, 100);
    }
    function cerrarSearch(restoreFocus) {
      if (!search || !search.classList.contains('pah__search--abierto')) return;
      search.classList.remove('pah__search--abierto');
      search.setAttribute('aria-hidden', 'true');
      resetPredictive();
      unlockBody();
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
    }
    raiz.querySelectorAll('[data-pah-search-open]').forEach(function (btn) { btn.addEventListener('click', abrirSearch); });
    var searchClose = search ? search.querySelector('[data-pah-search-close]') : null;
    if (searchClose) searchClose.addEventListener('click', function () { cerrarSearch(true); });
    if (searchInput) searchInput.addEventListener('input', function () { buscarPredictivo(searchInput.value); });
    if (search) {
      var form = search.querySelector('.pah__search-form');
      if (form && searchInput) form.addEventListener('submit', function () { guardarReciente(searchInput.value); });
      var clearRecent = search.querySelector('[data-pah-recent-clear]');
      if (clearRecent) clearRecent.addEventListener('click', function () { try { localStorage.removeItem(RECENT_KEY); } catch (e) {} pintarRecientes(); });
      search.addEventListener('mousedown', function (e) { if (e.target === search) cerrarSearch(true); });
    }

    /* Scrim y teclado. */
    if (scrim) scrim.addEventListener('click', function () { cerrarDrawer(true); cerrarMega(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrarSearch(true); cerrarDrawer(true); cerrarMega(); }
      if (search && search.classList.contains('pah__search--abierto')) trapFocus(e, search);
      else if (drawer && drawer.classList.contains('pah__drawer--abierto')) trapFocus(e, drawer);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  else iniciar(document);
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

/* Sincroniza el contador del carrito con Ajax cart sin recargar. */
(function () {
  if (window.__ponteAuraCartWatcherV2) return;
  window.__ponteAuraCartWatcherV2 = true;
  var pending = false;

  function paintCount(n) {
    document.querySelectorAll('[data-pah-count], [data-pa-contador]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', Number(n) === 0);
      el.setAttribute('aria-label', n + ' productos en el carrito');
    });
  }
  function refreshCount() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0); })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  document.addEventListener('ponteaura:carrito', refreshCount);
  document.addEventListener('cart:updated', refreshCount);
  document.addEventListener('cart:refresh', refreshCount);

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var input = arguments[0];
      var url = '';
      try { url = input && input.url ? input.url : String(input || ''); } catch (e) {}
      var promise = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
        promise.then(function () { window.setTimeout(refreshCount, 60); }).catch(function () {});
      }
      return promise;
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype.open) {
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) window.setTimeout(refreshCount, 60);
      });
      return nativeOpen.apply(this, arguments);
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-chatbot"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar() {
    var raiz = document.querySelector('[data-pch]');
    if (!raiz || raiz.dataset.pchOk === '1') return;
    raiz.dataset.pchOk = '1';

    var panel = raiz.querySelector('[data-pch-panel]');
    var cuerpo = raiz.querySelector('[data-pch-cuerpo]');
    var chips = Array.prototype.slice.call(raiz.querySelectorAll('[data-pch-q]'));
    var reset = raiz.querySelector('[data-pch-reset]');
    var tit = raiz.querySelector('[data-pch-opciones-tit]');
    var punto = raiz.querySelector('[data-pch-punto]');
    var teaser = raiz.querySelector('[data-pch-teaser]');
    var abierto = false;

    function bajar() {
      if (cuerpo) window.setTimeout(function () { cuerpo.scrollTop = cuerpo.scrollHeight; }, 40);
    }

    function ocultarTeaser(recordar) {
      if (!teaser) return;
      teaser.hidden = true;
      if (recordar) { try { localStorage.setItem('ponteaura_chat_teaser', '1'); } catch (e) {} }
    }

    function abrir() {
      abierto = true;
      raiz.classList.add('pch--abierto');
      if (panel) panel.setAttribute('aria-hidden', 'false');
      if (punto) punto.classList.remove('pch__punto--on');
      ocultarTeaser(true);
      try { localStorage.setItem('ponteaura_chat_visto', '1'); } catch (e) {}
      bajar();
    }
    function cerrar() {
      abierto = false;
      raiz.classList.remove('pch--abierto');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    }

    var abrirBtn = raiz.querySelector('[data-pch-abrir]');
    if (abrirBtn) abrirBtn.addEventListener('click', function () { abierto ? cerrar() : abrir(); });
    var cerrarBtn = raiz.querySelector('[data-pch-cerrar]');
    if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
    if (teaser) {
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-pch-teaser-x]')) { ocultarTeaser(true); return; }
        abrir();
      });
    }

    function addMsg(texto, mio) {
      if (!cuerpo) return null;
      var fila = document.createElement('div');
      fila.className = 'pch__msg ' + (mio ? 'pch__msg--yo' : 'pch__msg--bot');
      var b = document.createElement('span');
      b.className = 'pch__burbuja';
      b.textContent = texto;
      fila.appendChild(b);
      cuerpo.appendChild(fila);
      bajar();
      return fila;
    }

    function addEscribiendo() {
      if (!cuerpo) return null;
      var fila = document.createElement('div');
      fila.className = 'pch__msg pch__msg--bot';
      var b = document.createElement('span');
      b.className = 'pch__burbuja pch__escribiendo';
      b.innerHTML = '<span></span><span></span><span></span>';
      fila.appendChild(b);
      cuerpo.appendChild(fila);
      bajar();
      return fila;
    }

    function revisarRestantes() {
      var quedan = chips.filter(function (c) { return !c.classList.contains('pch__chip--usado'); });
      if (tit) tit.textContent = quedan.length ? (tit.getAttribute('data-orig') || tit.textContent) : '';
      if (reset) reset.hidden = quedan.length > 0;
    }
    if (tit) tit.setAttribute('data-orig', tit.textContent);

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pregunta = chip.textContent.trim();
        var respuesta = chip.getAttribute('data-pch-respuesta') || '';
        chip.classList.add('pch__chip--usado');
        addMsg(pregunta, true);
        revisarRestantes();
        var esc = addEscribiendo();
        window.setTimeout(function () {
          if (esc && esc.parentNode) esc.parentNode.removeChild(esc);
          addMsg(respuesta, false);
        }, 620);
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('pch__chip--usado'); });
        revisarRestantes();
        bajar();
      });
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto) cerrar(); });

    var visto = false;
    try { visto = localStorage.getItem('ponteaura_chat_visto') === '1'; } catch (e) {}
    if (!visto && punto) window.setTimeout(function () { punto.classList.add('pch__punto--on'); }, 2500);

    if (teaser) {
      var teaserVisto = false;
      try { teaserVisto = localStorage.getItem('ponteaura_chat_teaser') === '1'; } catch (e) {}
      var demora = parseInt(raiz.getAttribute('data-pch-demora'), 10);
      if (isNaN(demora)) demora = 5;
      if (!teaserVisto && !visto) {
        window.setTimeout(function () { if (!abierto) teaser.hidden = false; }, demora * 1000);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raices = document.querySelectorAll('[data-pcf-raiz]');
  raices.forEach(function (raiz) {
    if (raiz.dataset.pcfInit === '1') return;
    raiz.dataset.pcfInit = '1';

    var form = raiz.querySelector('[data-pcf-form]');
    var sidebar = raiz.querySelector('[data-pcf-sidebar]');
    var velo = raiz.querySelector('[data-pcf-velo]');
    var sheet = raiz.querySelector('[data-pcf-orden-sheet]');
    var sortSelect = raiz.querySelector('[data-pcf-sort]');
    var abrirFiltros = raiz.querySelector('[data-pcf-abrir-filtros]');
    var abrirOrden = raiz.querySelector('[data-pcf-abrir-orden]');

    function esMovil() { return window.matchMedia('(max-width: 989px)').matches; }
    function enviar() { if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); } }

    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.matches('[data-pcf-check]') && !esMovil()) enviar();
      });
    }
    if (sortSelect) sortSelect.addEventListener('change', enviar);

    raiz.querySelectorAll('[data-pcf-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grupo = btn.closest('[data-pcf-grupo]');
        if (grupo) grupo.classList.toggle('pcf-grupo--cerrado');
      });
    });

    function abrirLateral() {
      if (!sidebar) return;
      sidebar.classList.add('pcf-sidebar--on'); sidebar.setAttribute('aria-hidden', 'false');
      if (velo) { velo.hidden = false; requestAnimationFrame(function () { velo.classList.add('pcf-velo--on'); }); }
      document.body.classList.add('pcf-lock');
    }
    function cerrarLateral() {
      if (!sidebar) return;
      sidebar.classList.remove('pcf-sidebar--on'); sidebar.setAttribute('aria-hidden', 'true');
      cerrarVelo();
    }
    function abrirSheet() {
      if (!sheet) return;
      sheet.classList.add('pcf-sheet--on'); sheet.setAttribute('aria-hidden', 'false');
      if (velo) { velo.hidden = false; requestAnimationFrame(function () { velo.classList.add('pcf-velo--on'); }); }
      document.body.classList.add('pcf-lock');
    }
    function cerrarSheet() {
      if (!sheet) return;
      sheet.classList.remove('pcf-sheet--on'); sheet.setAttribute('aria-hidden', 'true');
      cerrarVelo();
    }
    function cerrarVelo() {
      var lateralOn = sidebar && sidebar.classList.contains('pcf-sidebar--on');
      var sheetOn = sheet && sheet.classList.contains('pcf-sheet--on');
      if (!lateralOn && !sheetOn) {
        if (velo) { velo.classList.remove('pcf-velo--on'); setTimeout(function () { velo.hidden = true; }, 300); }
        document.body.classList.remove('pcf-lock');
      }
    }

    if (abrirFiltros) abrirFiltros.addEventListener('click', abrirLateral);
    if (abrirOrden) abrirOrden.addEventListener('click', abrirSheet);
    raiz.querySelectorAll('[data-pcf-cerrar-filtros]').forEach(function (b) { b.addEventListener('click', cerrarLateral); });
    raiz.querySelectorAll('[data-pcf-aplicar]').forEach(function (b) { b.addEventListener('click', enviar); });
    raiz.querySelectorAll('[data-pcf-cerrar-orden]').forEach(function (b) { b.addEventListener('click', cerrarSheet); });
    if (velo) velo.addEventListener('click', function () { cerrarLateral(); cerrarSheet(); });

    raiz.querySelectorAll('[data-pcf-orden-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-pcf-orden-val');
        if (sortSelect) { sortSelect.value = val; enviar(); }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      cerrarLateral(); cerrarSheet();
    });

    raiz.querySelectorAll('[data-pcf-add]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = f.querySelector('[data-pcf-add-btn]');
        var txt = f.querySelector('[data-pcf-add-txt]');
        var original = txt ? txt.textContent : '';
        if (boton) boton.classList.add('pcf-card__add--cargando');
        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            if (boton) { boton.classList.remove('pcf-card__add--cargando'); boton.classList.add('pcf-card__add--ok'); }
            if (txt) txt.textContent = 'A\u00f1adido';
            return fetch('/cart.js');
          })
          .then(function (r) { return r ? r.json() : null; })
          .then(function (cart) {
            if (cart) {
              document.querySelectorAll('[data-paura-carrito-num], [data-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (el) {
                el.textContent = cart.item_count;
                el.classList.remove('paura__carrito-num--0');
              });
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            setTimeout(function () {
              if (boton) boton.classList.remove('pcf-card__add--ok');
              if (txt) txt.textContent = original;
            }, 1800);
          })
          .catch(function () { if (boton) boton.classList.remove('pcf-card__add--cargando'); f.submit(); });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-colecciones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar() {
    var raiz = document.querySelector('[data-pcol]');
    if (!raiz || raiz.dataset.pcolOk === '1') return;
    raiz.dataset.pcolOk = '1';

    var input = raiz.querySelector('[data-pcol-buscar]');
    var limpiar = raiz.querySelector('[data-pcol-limpiar]');
    var cards = Array.prototype.slice.call(raiz.querySelectorAll('[data-pcol-nombre]'));
    var sin = raiz.querySelector('[data-pcol-sin]');
    if (!input) return;

    function normal(t) {
      return ('' + t).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function filtrar() {
      var q = normal(input.value.trim());
      var visibles = 0;
      cards.forEach(function (c) {
        var nombre = normal(c.getAttribute('data-pcol-nombre') || '');
        var ok = q === '' || nombre.indexOf(q) !== -1;
        c.classList.toggle('pcol__card--oculta', !ok);
        if (ok) visibles++;
      });
      if (sin) sin.hidden = visibles !== 0;
      if (limpiar) limpiar.hidden = input.value === '';
    }

    input.addEventListener('input', filtrar);
    if (limpiar) limpiar.addEventListener('click', function () { input.value = ''; filtrar(); input.focus(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-combos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(scope) {
    var raiz = (scope && scope.querySelector) ? scope.querySelector('[data-pcb]') : document.querySelector('[data-pcb]:not([data-pcb-ok])');
    if (!raiz || raiz.dataset.pcbOk === '1') return;
    raiz.dataset.pcbOk = '1';

    var tabs = Array.prototype.slice.call(raiz.querySelectorAll('[data-pcb-tab]'));
    var paneles = Array.prototype.slice.call(raiz.querySelectorAll('[data-pcb-panel]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-pcb-tab');
        tabs.forEach(function (t) { t.classList.toggle('pcb__tab--on', t === tab); });
        paneles.forEach(function (p) { p.classList.toggle('pcb__panel--on', p.getAttribute('data-pcb-panel') === id); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-destacados-nuevos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raices = document.querySelectorAll('[data-pad-raiz]');
  raices.forEach(function (raiz) {
    if (raiz.dataset.padInit === '1') return;
    raiz.dataset.padInit = '1';

    var tabs = raiz.querySelectorAll('[data-pad-tab]');
    var panels = raiz.querySelectorAll('[data-pad-panel]');

    function activar(i) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-pad-tab') === i;
        t.classList.toggle('pad-tab--activo', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-pad-panel') === i;
        p.classList.toggle('pad-panel--activo', on);
        if (on) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activar(t.getAttribute('data-pad-tab')); });
    });

    raiz.querySelectorAll('[data-pad-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = form.querySelector('[data-pad-add-btn]');
        var txt = form.querySelector('[data-pad-add-txt]');
        var original = txt ? txt.textContent : '';
        if (boton) boton.classList.add('pad-card__add--cargando');
        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            if (boton) { boton.classList.remove('pad-card__add--cargando'); boton.classList.add('pad-card__add--ok'); }
            if (txt) txt.textContent = 'A\u00f1adido';
            return fetch('/cart.js');
          })
          .then(function (r) { return r ? r.json() : null; })
          .then(function (cart) {
            if (cart) {
              document.querySelectorAll('[data-paura-carrito-num], [data-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (el) {
                el.textContent = cart.item_count;
                el.classList.remove('paura__carrito-num--0');
              });
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            setTimeout(function () {
              if (boton) boton.classList.remove('pad-card__add--ok');
              if (txt) txt.textContent = original;
            }, 1800);
          })
          .catch(function () {
            if (boton) boton.classList.remove('pad-card__add--cargando');
            form.submit();
          });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-familias"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFam(raiz) {
    if (!raiz || raiz.dataset.paIniciado === '1') return;
    raiz.dataset.paIniciado = '1';

    var seguidor = raiz.querySelector('[data-pa-fam-seguidor]');
    var seguidorImg = raiz.querySelector('[data-pa-fam-seguidor-img]');
    var filas = raiz.querySelectorAll('[data-pa-fam-fila]');
    if (!seguidor || !filas.length) return;

    var fino = window.matchMedia('(hover: hover) and (min-width: 990px)');
    if (!fino.matches) return;

    var destinoX = 0, destinoY = 0, actualX = 0, actualY = 0, animando = false;

    function bucle() {
      actualX += (destinoX - actualX) * 0.12;
      actualY += (destinoY - actualY) * 0.12;
      seguidor.style.transform = 'translate3d(' + actualX + 'px,' + actualY + 'px,0)';
      if (animando) window.requestAnimationFrame(bucle);
    }

    function encender(fila) {
      var src = fila.getAttribute('data-pa-fam-img');
      if (!src || !seguidorImg) return;
      seguidorImg.src = src;
      seguidor.classList.add('pa-fam__seguidor--visible');
      if (!animando) { animando = true; window.requestAnimationFrame(bucle); }
    }
    function apagar() {
      seguidor.classList.remove('pa-fam__seguidor--visible');
      window.setTimeout(function () {
        if (!seguidor.classList.contains('pa-fam__seguidor--visible')) animando = false;
      }, 420);
    }

    for (var i = 0; i < filas.length; i++) {
      (function (fila) {
        fila.addEventListener('mouseenter', function (e) {
          destinoX = actualX = e.clientX;
          destinoY = actualY = e.clientY;
          encender(fila);
        });
        fila.addEventListener('mousemove', function (e) {
          destinoX = e.clientX;
          destinoY = e.clientY;
        });
        fila.addEventListener('mouseleave', apagar);
      })(filas[i]);
    }
  }

  function iniciarTodos() {
    var lista = document.querySelectorAll('[data-pa-fam]');
    for (var i = 0; i < lista.length; i++) iniciarFam(lista[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodos);
  else iniciarTodos();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pa-fam]');
    if (r) iniciarFam(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-main-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarArt(raiz) {
    if (!raiz || raiz.dataset.paIniciado === '1') return;
    raiz.dataset.paIniciado = '1';

    var cuerpo = raiz.querySelector('[data-pa-art-cuerpo]');
    var barra = raiz.querySelector('[data-pa-art-barra]');

    if (cuerpo && barra) {
      var pendiente = false;
      function progreso() {
        var caja = cuerpo.getBoundingClientRect();
        var alto = window.innerHeight || 0;
        var total = caja.height - alto;
        var pct = total > 0 ? ((alto - caja.top - alto * 0.15) / total) * 100 : 0;
        pct = Math.max(0, Math.min(100, pct));
        barra.style.width = pct + '%';
        pendiente = false;
      }
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; window.requestAnimationFrame(progreso); }
      }, { passive: true });
      window.addEventListener('resize', progreso);
      progreso();
    }

    var portada = raiz.querySelector('[data-pa-art-parallax]');
    if (portada && window.matchMedia('(min-width: 749px)').matches) {
      var pend2 = false;
      function mover() {
        var y = window.pageYOffset || 0;
        if (y < window.innerHeight * 1.3) portada.style.transform = 'translateY(' + (y * 0.14) + 'px)';
        pend2 = false;
      }
      window.addEventListener('scroll', function () {
        if (!pend2) { pend2 = true; window.requestAnimationFrame(mover); }
      }, { passive: true });
      mover();
    }

    var indice = raiz.querySelector('[data-pa-art-indice]');
    var lista = raiz.querySelector('[data-pa-art-indice-lista]');
    if (indice && lista && cuerpo) {
      var titulos = cuerpo.querySelectorAll('h2, h3');
      var enlaces = [];
      var validos = [];
      for (var i = 0; i < titulos.length; i++) {
        var t = titulos[i];
        var texto = (t.textContent || '').trim();
        if (!texto) continue;
        if (!t.id) t.id = 'pa-sec-' + i + '-' + texto.toLowerCase().replace(/[^a-z0-9\u00e0-\u00ff]+/g, '-').slice(0, 40);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + t.id;
        a.textContent = texto;
        if (t.tagName.toLowerCase() === 'h3') a.className = 'pa-art__indice--h3';
        li.appendChild(a);
        lista.appendChild(li);
        enlaces.push(a);
        validos.push(t);
      }

      if (enlaces.length > 1) {
        indice.hidden = false;

        for (var k = 0; k < enlaces.length; k++) {
          (function (a, destino) {
            a.addEventListener('click', function (e) {
              e.preventDefault();
              var top = destino.getBoundingClientRect().top + (window.pageYOffset || 0) - 80;
              window.scrollTo({ top: top, behavior: 'smooth' });
            });
          })(enlaces[k], validos[k]);
        }

        if ('IntersectionObserver' in window) {
          var obs = new IntersectionObserver(function (entradas) {
            entradas.forEach(function (ent) {
              if (!ent.isIntersecting) return;
              for (var m = 0; m < enlaces.length; m++) enlaces[m].classList.remove('pa-art__indice--activo');
              var idx = validos.indexOf(ent.target);
              if (idx > -1) enlaces[idx].classList.add('pa-art__indice--activo');
            });
          }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });
          for (var n = 0; n < validos.length; n++) obs.observe(validos[n]);
        }
      }
    }

    var copiar = raiz.querySelector('[data-pa-art-copiar]');
    var copiado = raiz.querySelector('[data-pa-art-copiado]');
    if (copiar) {
      copiar.addEventListener('click', function () {
        var url = copiar.getAttribute('data-url') || window.location.href;
        function ok() {
          if (!copiado) return;
          copiado.hidden = false;
          window.setTimeout(function () { copiado.hidden = true; }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(ok).catch(function () {});
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); ok(); } catch (e) {}
          document.body.removeChild(tmp);
        }
      });
    }

    raiz.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-pa-art-add]');
      if (!boton || boton.disabled) return;
      e.preventDefault();
      var id = boton.getAttribute('data-pa-art-add');
      var etiqueta = boton.querySelector('span');
      var original = etiqueta ? etiqueta.textContent : '';
      boton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          if (etiqueta) etiqueta.textContent = 'A\u00f1adido';
          boton.classList.add('pa-art__prod-add--ok');
          if (window.PonteAuraCart && typeof window.PonteAuraCart.abrir === 'function') window.PonteAuraCart.abrir();
          window.setTimeout(function () {
            if (etiqueta) etiqueta.textContent = original;
            boton.classList.remove('pa-art__prod-add--ok');
            boton.disabled = false;
          }, 1600);
        })
        .catch(function () { boton.disabled = false; window.location.href = '/cart'; });
    });
  }

  function iniciarTodos() {
    var lista = document.querySelectorAll('[data-pa-art]');
    for (var i = 0; i < lista.length; i++) iniciarArt(lista[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodos);
  else iniciarTodos();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pa-art]');
    if (r) iniciarArt(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-main-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar() {
    var raiz = document.querySelector('[data-pbs]');
    if (!raiz || raiz.dataset.pbsOk === '1') return;
    raiz.dataset.pbsOk = '1';

    var CLAVE = 'ponteaura_busquedas';
    var input = raiz.querySelector('[data-pbs-input]');
    var limpiar = raiz.querySelector('[data-pbs-limpiar]');
    var resumen = raiz.querySelector('[data-pbs-termino]');
    var termino = resumen ? (resumen.getAttribute('data-pbs-termino') || '') : '';

    function leer() {
      try { return JSON.parse(localStorage.getItem(CLAVE) || '[]'); } catch (e) { return []; }
    }
    function guardar(x) {
      x = (x || '').trim();
      if (!x) return;
      var lista = leer().filter(function (v) { return v.toLowerCase() !== x.toLowerCase(); });
      lista.unshift(x);
      try { localStorage.setItem(CLAVE, JSON.stringify(lista.slice(0, 8))); } catch (e) {}
    }
    if (termino) guardar(termino);

    var fila = raiz.querySelector('[data-pbs-recientes-fila]');
    var cont = raiz.querySelector('[data-pbs-recientes]');
    function pintar() {
      if (!fila || !cont) return;
      var lista = leer().filter(function (v) { return v.toLowerCase() !== termino.toLowerCase(); });
      if (!lista.length) { fila.hidden = true; return; }
      fila.hidden = false;
      cont.innerHTML = '';
      lista.slice(0, 6).forEach(function (t) {
        var a = document.createElement('a');
        a.className = 'pbs__chip';
        a.href = '/search?q=' + encodeURIComponent(t) + '&type=product,article,page';
        a.textContent = t;
        cont.appendChild(a);
      });
    }
    pintar();
    var borrar = raiz.querySelector('[data-pbs-borrar-recientes]');
    if (borrar) borrar.addEventListener('click', function () { try { localStorage.removeItem(CLAVE); } catch (e) {} pintar(); });

    function verLimpiar() { if (limpiar) limpiar.hidden = !(input && input.value); }
    if (input) { verLimpiar(); input.addEventListener('input', verLimpiar); }
    if (limpiar) limpiar.addEventListener('click', function () { if (input) { input.value = ''; input.focus(); } verLimpiar(); });

    if (termino) {
      var palabras = termino.split(/\s+/).filter(function (p) { return p.length > 2; });
      if (palabras.length) {
        var patron = palabras.map(function (p) { return p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|');
        var re = new RegExp('(' + patron + ')', 'gi');
        raiz.querySelectorAll('[data-pbs-resaltar]').forEach(function (el) {
          var texto = el.textContent;
          if (!re.test(texto)) { re.lastIndex = 0; return; }
          re.lastIndex = 0;
          el.textContent = '';
          var ultimo = 0, m;
          while ((m = re.exec(texto)) !== null) {
            if (m.index > ultimo) el.appendChild(document.createTextNode(texto.slice(ultimo, m.index)));
            var mark = document.createElement('mark');
            mark.className = 'pbs__marca-hit';
            mark.textContent = m[0];
            el.appendChild(mark);
            ultimo = m.index + m[0].length;
            if (m[0].length === 0) re.lastIndex++;
          }
          if (ultimo < texto.length) el.appendChild(document.createTextNode(texto.slice(ultimo)));
        });
      }
    }

    var orden = raiz.querySelector('[data-pbs-orden]');
    if (orden) orden.addEventListener('change', function () { var f = orden.closest('form'); if (f) f.submit(); });

    raiz.querySelectorAll('[data-pbs-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = form.querySelector('.pbs__card-add');
        var txt = form.querySelector('[data-pbs-add-txt]');
        var original = txt ? txt.textContent : '';
        var id = form.querySelector('input[name="id"]');
        if (!id) return;
        if (boton) boton.classList.add('pbs__card-add--cargando');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: id.value, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            if (boton) { boton.classList.remove('pbs__card-add--cargando'); boton.classList.add('pbs__card-add--ok'); }
            if (txt) txt.textContent = 'A\u00f1adido';
            if (window.PonteAuraCart && typeof window.PonteAuraCart.abrir === 'function') window.PonteAuraCart.abrir();
            document.dispatchEvent(new CustomEvent('ponteaura:carrito', { bubbles: true }));
            setTimeout(function () {
              if (boton) boton.classList.remove('pbs__card-add--ok');
              if (txt) txt.textContent = original;
            }, 1800);
          })
          .catch(function () {
            if (boton) boton.classList.remove('pbs__card-add--cargando');
            window.location.href = '/cart';
          });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE = 'ponteaura_promo';

  function estado() {
    try { return localStorage.getItem(CLAVE); } catch (e) { return null; }
  }
  function guardar(valor) {
    try { localStorage.setItem(CLAVE, valor); } catch (e) {}
  }

  function iniciarPop(raiz) {
    if (!raiz || raiz.dataset.paIniciado === '1') return;
    raiz.dataset.paIniciado = '1';

    var caja = raiz.querySelector('[data-pa-pop-caja]');
    var velo = raiz.querySelector('[data-pa-pop-velo]');
    var burbuja = raiz.querySelector('[data-pa-pop-burbuja]');
    var input = raiz.querySelector('[data-pa-pop-input]');
    var enviar = raiz.querySelector('[data-pa-pop-enviar]');
    var enviarTexto = raiz.querySelector('[data-pa-pop-enviar-texto]');
    var error = raiz.querySelector('[data-pa-pop-error]');
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var temporizador = null;

    function abrir() {
      raiz.classList.add('pa-pop--abierto');
      caja.setAttribute('aria-hidden', 'false');
      ocultarBurbuja();
    }
    function cerrar() {
      raiz.classList.remove('pa-pop--abierto');
      caja.setAttribute('aria-hidden', 'true');
      if (estado() !== 'suscrito') {
        guardar('cerrado');
        mostrarBurbuja();
      }
    }
    function mostrarBurbuja() {
      if (burbuja) burbuja.classList.add('pa-pop__burbuja--visible');
    }
    function ocultarBurbuja() {
      if (burbuja) burbuja.classList.remove('pa-pop__burbuja--visible');
    }
    function voltear() {
      raiz.classList.add('pa-pop--volteado');
    }

    var cerradores = raiz.querySelectorAll('[data-pa-pop-cerrar]');
    for (var i = 0; i < cerradores.length; i++) cerradores[i].addEventListener('click', cerrar);
    if (velo) velo.addEventListener('click', cerrar);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && raiz.classList.contains('pa-pop--abierto')) cerrar();
    });
    if (burbuja) burbuja.addEventListener('click', abrir);

    var copiar = raiz.querySelector('[data-pa-pop-copiar]');
    if (copiar) {
      copiar.addEventListener('click', function () {
        var codigo = copiar.getAttribute('data-codigo') || '';
        var etiqueta = raiz.querySelector('[data-pa-pop-copiar-texto]');
        function ok() {
          if (etiqueta) {
            etiqueta.textContent = 'Copiado';
            window.setTimeout(function () { etiqueta.textContent = 'Copiar'; }, 1800);
          }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(ok).catch(function () {});
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = codigo;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); ok(); } catch (e) {}
          document.body.removeChild(tmp);
        }
      });
    }

    function mostrarError(msg) {
      if (!error) return;
      error.textContent = msg;
      error.hidden = false;
    }

    function suscribir() {
      if (error) error.hidden = true;
      var correo = input ? input.value.trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(correo)) {
        mostrarError('Escribe un correo v\u00e1lido.');
        if (input) input.focus();
        return;
      }

      if (enviar) enviar.disabled = true;
      if (enviarTexto) enviarTexto.textContent = 'Enviando...';

      var datos = new FormData();
      datos.append('form_type', 'customer');
      datos.append('utf8', '\u2713');
      datos.append('contact[email]', correo);
      datos.append('contact[tags]', 'newsletter, popup-descuento');

      fetch('/contact', { method: 'POST', body: datos })
        .then(function () { guardar('suscrito'); voltear(); })
        .catch(function () { guardar('suscrito'); voltear(); });
    }

    if (enviar) enviar.addEventListener('click', suscribir);
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); suscribir(); }
      });
    }

    if (editor) {
      abrir();
      return;
    }

    var guardado = estado();
    if (guardado === 'suscrito') return;
    if (guardado === 'cerrado') { mostrarBurbuja(); return; }

    var retraso = parseInt(raiz.getAttribute('data-retraso'), 10);
    if (isNaN(retraso)) retraso = 6;
    temporizador = window.setTimeout(abrir, retraso * 1000);

    if (raiz.getAttribute('data-salida') === 'true') {
      document.addEventListener('mouseout', function salir(e) {
        if (e.clientY > 0 || e.relatedTarget || estado()) return;
        if (temporizador) window.clearTimeout(temporizador);
        abrir();
        document.removeEventListener('mouseout', salir);
      });
    }
  }

  function iniciarTodos() {
    var lista = document.querySelectorAll('[data-pa-pop]');
    for (var i = 0; i < lista.length; i++) iniciarPop(lista[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodos);
  else iniciarTodos();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pa-pop]');
    if (r) iniciarPop(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-producto-destacado"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(scope) {
    var raiz = (scope && scope.querySelector) ? scope.querySelector('[data-pfd]') : document.querySelector('[data-pfd]:not([data-pfd-ok])');
    if (!raiz) return;
    if (raiz.dataset.pfdOk === '1') return;
    raiz.dataset.pfdOk = '1';

    var variantes = [];
    try {
      var vEl = raiz.querySelector('[data-pfd-variantes]');
      if (vEl) variantes = JSON.parse(vEl.textContent);
    } catch (e) {}

    var slides = Array.prototype.slice.call(raiz.querySelectorAll('[data-pfd-slide]'));
    var puntos = Array.prototype.slice.call(raiz.querySelectorAll('[data-pfd-punto], .pfd__punto'));
    var minis = Array.prototype.slice.call(raiz.querySelectorAll('.pfd__mini'));
    var actual = 0;

    function ir(n) {
      if (!slides.length) return;
      actual = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('pfd__slide--on', i === actual); });
      raiz.querySelectorAll('.pfd__punto').forEach(function (p, i) { p.classList.toggle('pfd__punto--on', i === actual); });
      minis.forEach(function (m, i) { m.classList.toggle('pfd__mini--on', i === actual); });
    }
    raiz.querySelectorAll('[data-pfd-ir]').forEach(function (b) {
      b.addEventListener('click', function () { ir(parseInt(b.getAttribute('data-pfd-ir'), 10) || 0); });
    });

    var galeria = raiz.querySelector('[data-pfd-galeria]');
    if (galeria && slides.length > 1) {
      var x0 = null;
      galeria.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      galeria.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    var seleccion = [];
    raiz.querySelectorAll('[data-pfd-opcion]').forEach(function (op, idx) {
      var activo = op.querySelector('.pfd__val--on');
      seleccion[idx] = activo ? activo.getAttribute('data-pfd-valor') : null;
    });

    var idInput = raiz.querySelector('[data-pfd-id]');
    var precioEl = raiz.querySelector('[data-pfd-precio]');
    var antesEl = raiz.querySelector('[data-pfd-antes]');
    var addPrecioEl = raiz.querySelector('[data-pfd-add-precio]');
    var addBtn = raiz.querySelector('[data-pfd-add]');
    var addTxt = raiz.querySelector('[data-pfd-add-txt]');
    var yaBtn = raiz.querySelector('[data-pfd-ya]');

    function money(cents) {
      var v = (cents || 0) / 100;
      try { return v.toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
      catch (e) { return '$' + v.toFixed(0); }
    }

    function coincide(variant) {
      var opts = variant.options || [];
      for (var i = 0; i < seleccion.length; i++) {
        if (seleccion[i] !== null && opts[i] !== seleccion[i]) return false;
      }
      return true;
    }

    function actualizar() {
      if (!variantes.length) return;
      var v = null;
      for (var i = 0; i < variantes.length; i++) { if (coincide(variantes[i])) { v = variantes[i]; break; } }
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (precioEl) precioEl.textContent = money(v.price);
      if (addPrecioEl) addPrecioEl.textContent = money(v.price);
      if (antesEl) { if (v.compare_at_price && v.compare_at_price > v.price) { antesEl.textContent = money(v.compare_at_price); antesEl.style.display = ''; } else { antesEl.style.display = 'none'; } }
      var disp = v.available;
      if (addBtn) { addBtn.disabled = !disp; if (addTxt && !disp) addTxt.textContent = raiz.getAttribute('data-pfd-agotado') || 'Agotado'; }
      if (yaBtn) yaBtn.disabled = !disp;
    }

    raiz.querySelectorAll('[data-pfd-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-pfd-opidx'), 10);
        seleccion[idx] = btn.getAttribute('data-pfd-valor');
        var cont = btn.closest('[data-pfd-opcion]');
        if (cont) cont.querySelectorAll('[data-pfd-val]').forEach(function (b) { b.classList.toggle('pfd__val--on', b === btn); });
        actualizar();
      });
    });

    var cant = 1;
    var cantEl = raiz.querySelector('[data-pfd-cant]');
    var mas = raiz.querySelector('[data-pfd-mas]');
    var menos = raiz.querySelector('[data-pfd-menos]');
    function pintarCant() { if (cantEl) cantEl.textContent = cant; }
    if (mas) mas.addEventListener('click', function () { cant++; pintarCant(); });
    if (menos) menos.addEventListener('click', function () { if (cant > 1) { cant--; pintarCant(); } });

    var form = raiz.querySelector('[data-pfd-form]');
    var enviando = false;
    function agregar() {
      var id = idInput ? idInput.value : null;
      if (!id) return Promise.resolve();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: cant }] })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (enviando) return;
        enviando = true;
        if (addBtn) addBtn.disabled = true;
        var textoOrig = addTxt ? addTxt.textContent : '';
        agregar().then(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.classList.add('pfd__add--ok'); }
          if (addTxt) addTxt.textContent = 'A\u00f1adido';
          if (window.PonteAuraCart && window.PonteAuraCart.abrir) window.PonteAuraCart.abrir();
          document.dispatchEvent(new CustomEvent('ponteaura:carrito', { bubbles: true }));
          setTimeout(function () { if (addBtn) addBtn.classList.remove('pfd__add--ok'); if (addTxt) addTxt.textContent = textoOrig; }, 1700);
          enviando = false;
        }).catch(function () { enviando = false; if (addBtn) addBtn.disabled = false; });
      });
    }

    if (yaBtn) {
      yaBtn.addEventListener('click', function () {
        if (yaBtn.disabled) return;
        yaBtn.disabled = true;
        agregar().then(function () { window.location.href = '/checkout'; })
          .catch(function () { yaBtn.disabled = false; });
      });
    }

    actualizar();
    pintarCant();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-ranking"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarRank(raiz) {
    if (!raiz || raiz.dataset.paIniciado === '1') return;
    raiz.dataset.paIniciado = '1';

    var riel = raiz.querySelector('[data-pa-rank-riel]');

    function desplazar(dir) {
      if (!riel) return;
      var card = riel.querySelector('.pa-rank__card');
      var paso = card ? (card.offsetWidth + 16) * 2 : riel.clientWidth * 0.8;
      riel.scrollBy({ left: dir * paso, behavior: 'smooth' });
    }
    var prev = raiz.querySelector('[data-pa-rank-prev]');
    if (prev) prev.addEventListener('click', function () { desplazar(-1); });
    var next = raiz.querySelector('[data-pa-rank-next]');
    if (next) next.addEventListener('click', function () { desplazar(1); });

    raiz.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-pa-rank-add]');
      if (!boton || boton.disabled) return;
      e.preventDefault();
      var id = boton.getAttribute('data-pa-rank-add');
      var etiqueta = boton.querySelector('span');
      var original = etiqueta ? etiqueta.textContent : '';
      boton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          if (etiqueta) etiqueta.textContent = 'Añadido';
          boton.classList.add('pa-rank__add--ok');
          if (window.PonteAuraCart && typeof window.PonteAuraCart.abrir === 'function') {
            window.PonteAuraCart.abrir();
          }
          window.setTimeout(function () {
            if (etiqueta) etiqueta.textContent = original;
            boton.classList.remove('pa-rank__add--ok');
            boton.disabled = false;
          }, 1600);
        })
        .catch(function () {
          boton.disabled = false;
          window.location.href = '/cart';
        });
    });
  }

  function iniciarTodos() {
    var lista = document.querySelectorAll('[data-pa-rank]');
    for (var i = 0; i < lista.length; i++) iniciarRank(lista[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodos);
  else iniciarTodos();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pa-rank]');
    if (r) iniciarRank(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-decants"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar() {
    var raiz = document.querySelector('[data-pdc]');
    if (!raiz || raiz.dataset.pdcOk === '1') return;
    raiz.dataset.pdcOk = '1';

    var cards = Array.prototype.slice.call(raiz.querySelectorAll('[data-pdc-card]'));
    var input = raiz.querySelector('[data-pdc-buscar]');
    var limpiar = raiz.querySelector('[data-pdc-limpiar]');
    var filtros = Array.prototype.slice.call(raiz.querySelectorAll('[data-pdc-tag]'));
    var conteo = raiz.querySelector('[data-pdc-conteo]');
    var vacio = raiz.querySelector('[data-pdc-vacio]');
    var minimo = parseInt(raiz.getAttribute('data-minimo'), 10) || 3;

    function normal(t) { return ('' + t).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }

    var tagActivo = '';
    function filtrar() {
      var q = normal(input ? input.value.trim() : '');
      var visibles = 0;
      cards.forEach(function (c) {
        var tags = normal(c.getAttribute('data-tags') || '');
        var nombre = normal(c.getAttribute('data-nombre') || '');
        var marca = normal(c.getAttribute('data-marca') || '');
        var okTag = tagActivo === '' || tags.split(',').indexOf(tagActivo) !== -1;
        var okQ = q === '' || nombre.indexOf(q) !== -1 || marca.indexOf(q) !== -1;
        var ok = okTag && okQ;
        c.classList.toggle('pdc__card--oculta', !ok);
        if (ok) visibles++;
      });
      if (vacio) vacio.hidden = visibles !== 0;
      if (conteo) conteo.textContent = visibles + (visibles === 1 ? ' decant' : ' decants');
      if (limpiar && input) limpiar.hidden = input.value === '';
    }

    if (input) input.addEventListener('input', filtrar);
    if (limpiar) limpiar.addEventListener('click', function () { if (input) { input.value = ''; input.focus(); } filtrar(); });
    filtros.forEach(function (f) {
      f.addEventListener('click', function () {
        tagActivo = normal(f.getAttribute('data-pdc-tag') || '');
        filtros.forEach(function (o) { o.classList.toggle('pdc__filtro--on', o === f); });
        filtrar();
      });
    });
    filtrar();

    cards.forEach(function (card) {
      var tallas = Array.prototype.slice.call(card.querySelectorAll('[data-pdc-var]'));
      var idInput = card.querySelector('[data-pdc-id]');
      var precio = card.querySelector('[data-pdc-precio]');
      tallas.forEach(function (t) {
        t.addEventListener('click', function () {
          if (t.disabled) return;
          tallas.forEach(function (o) { o.classList.toggle('pdc__talla--on', o === t); });
          if (idInput) idInput.value = t.getAttribute('data-pdc-var');
          if (precio) precio.textContent = t.getAttribute('data-precio') || precio.textContent;
        });
      });
    });

    var kit = raiz.querySelector('[data-pdc-kit]');
    var kitTitulo = raiz.querySelector('[data-pdc-kit-titulo]');
    var kitSub = raiz.querySelector('[data-pdc-kit-sub]');
    var kitPuntos = raiz.querySelector('[data-pdc-puntos]');
    var kitAdd = raiz.querySelector('[data-pdc-kit-add]');
    var kitBoton = raiz.querySelector('[data-pdc-kit-boton]');
    var kitLimpiar = raiz.querySelector('[data-pdc-kit-limpiar]');
    var elegidos = [];

    function pintarKit() {
      var n = elegidos.length;
      if (kit) {
        kit.classList.toggle('pdc__kit--visible', n > 0);
        kit.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
      }
      if (kitPuntos) {
        var total = Math.max(minimo, n);
        var html = '';
        for (var i = 0; i < total; i++) html += '<span class="pdc__kit-punto' + (i < n ? ' pdc__kit-punto--on' : '') + '"></span>';
        kitPuntos.innerHTML = html;
      }
      if (kitTitulo) kitTitulo.textContent = n + (n === 1 ? ' decant elegido' : ' decants elegidos');
      if (kitSub) {
        if (n < minimo) {
          var faltan = minimo - n;
          kitSub.textContent = 'Elige ' + faltan + ' m\u00e1s para completar tu kit de ' + minimo;
        } else {
          kitSub.textContent = '\u00a1Listo! Tu kit est\u00e1 completo';
        }
      }
    }

    cards.forEach(function (card) {
      var pick = card.querySelector('[data-pdc-pick]');
      if (!pick) return;
      pick.addEventListener('click', function () {
        var idInput = card.querySelector('[data-pdc-id]');
        if (!idInput) return;
        var i = elegidos.indexOf(card);
        if (i === -1) { elegidos.push(card); card.classList.add('pdc__card--elegida'); }
        else { elegidos.splice(i, 1); card.classList.remove('pdc__card--elegida'); }
        pintarKit();
      });
    });

    if (kitLimpiar) {
      kitLimpiar.addEventListener('click', function () {
        elegidos.forEach(function (c) { c.classList.remove('pdc__card--elegida'); });
        elegidos = [];
        pintarKit();
      });
    }

    if (kitAdd) {
      kitAdd.addEventListener('click', function () {
        if (!elegidos.length) return;
        var items = [];
        elegidos.forEach(function (c) {
          var idInput = c.querySelector('[data-pdc-id]');
          if (idInput && idInput.value) items.push({ id: idInput.value, quantity: 1 });
        });
        if (!items.length) return;
        kitAdd.disabled = true;
        var textoPrevio = kitBoton ? kitBoton.textContent : '';
        if (kitBoton) kitBoton.textContent = 'A\u00f1adiendo...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            if (kitBoton) kitBoton.textContent = '\u00a1Listo!';
            document.dispatchEvent(new CustomEvent('ponteaura:carrito', { bubbles: true }));
            window.setTimeout(function () { window.location.href = '/cart'; }, 600);
          })
          .catch(function () {
            kitAdd.disabled = false;
            if (kitBoton) kitBoton.textContent = textoPrevio;
          });
      });
    }

    pintarKit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paginaproducto-pa"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

  if (!window.paCarritoVigilado) {
    window.paCarritoVigilado = true;

    var avisarCarrito = function () {
      window.setTimeout(function () {
        try { window.dispatchEvent(new CustomEvent('ponteaura:carrito')); }
        catch (e) {
          var ev = document.createEvent('Event');
          ev.initEvent('ponteaura:carrito', true, true);
          window.dispatchEvent(ev);
        }
      }, 150);
    };

    var esRutaCarrito = function (url) {
      if (!url) return false;
      if (typeof url !== 'string') url = String(url);
      return url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 ||
             url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1;
    };

    if (window.fetch) {
      var fetchOriginal = window.fetch;
      window.fetch = function () {
        var destino = arguments[0];
        if (destino && destino.url) destino = destino.url;
        var promesa = fetchOriginal.apply(this, arguments);
        if (esRutaCarrito(destino)) {
          promesa.then(function () { avisarCarrito(); }).catch(function () {});
        }
        return promesa;
      };
    }

    if (window.XMLHttpRequest) {
      var abrirOriginal = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (metodo, url) {
        this.paUrl = url;
        return abrirOriginal.apply(this, arguments);
      };
      var enviarOriginal = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        var peticion = this;
        peticion.addEventListener('load', function () {
          if (esRutaCarrito(peticion.paUrl)) avisarCarrito();
        });
        return enviarOriginal.apply(this, arguments);
      };
    }
  }

  function iniciarProd(raiz) {
    if (!raiz || raiz.dataset.paIniciado === '1') return;
    raiz.dataset.paIniciado = '1';

    var handleActual = raiz.getAttribute('data-pa-track');

    try {
      if (handleActual) {
        var claveVistos = 'ponteaura_vistos';
        var vistos = JSON.parse(localStorage.getItem(claveVistos) || '[]');
        vistos = vistos.filter(function (h) { return h !== handleActual; });
        vistos.unshift(handleActual);
        localStorage.setItem(claveVistos, JSON.stringify(vistos.slice(0, 20)));
      }
    } catch (e) {}

    function formatearPrecio(centavos) {
      var valor = (centavos / 100);
      try {
        return valor.toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      } catch (e) {
        return '$' + valor.toFixed(0);
      }
    }

    var viendo = raiz.querySelector('[data-pa-viendo]');
    if (viendo) {
      var vNum = raiz.querySelector('[data-pa-viendo-num]');
      var vMin = parseInt(viendo.getAttribute('data-min'), 10) || 6;
      var vMax = parseInt(viendo.getAttribute('data-max'), 10) || 24;
      if (vMax < vMin) vMax = vMin;

      var semilla = 0;
      var base = (handleActual || '') + new Date().toDateString() + Math.floor(Date.now() / 3600000);
      for (var s = 0; s < base.length; s++) semilla = (semilla * 31 + base.charCodeAt(s)) % 100000;

      var actual = vMin + (semilla % (vMax - vMin + 1));
      function pintarViendo() { if (vNum) vNum.textContent = actual; }
      pintarViendo();

      window.setInterval(function () {
        var paso = Math.random() < 0.5 ? -1 : 1;
        if (Math.random() < 0.35) paso = paso * 2;
        actual = Math.min(vMax, Math.max(vMin, actual + paso));
        pintarViendo();
      }, 9000);
    }

    var slides = raiz.querySelectorAll('[data-pa-slide]');
    var puntos = raiz.querySelectorAll('[data-pa-g-ir]');
    var indice = 0;

    function mostrarMedia(n) {
      if (!slides.length) return;
      indice = (n + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('pa-prod__slide--activo', i === indice);
      }
      var pts = raiz.querySelectorAll('[data-pa-g-puntos] .pa-prod__punto');
      for (var j = 0; j < pts.length; j++) pts[j].classList.toggle('pa-prod__punto--activo', j === indice);
      var minis = raiz.querySelectorAll('.pa-prod__miniatura');
      for (var k = 0; k < minis.length; k++) minis[k].classList.toggle('pa-prod__miniatura--activa', k === indice);
    }

    for (var b = 0; b < puntos.length; b++) {
      puntos[b].addEventListener('click', function () { mostrarMedia(parseInt(this.getAttribute('data-pa-g-ir'), 10)); });
    }
    var gPrev = raiz.querySelector('[data-pa-g-prev]');
    if (gPrev) gPrev.addEventListener('click', function () { mostrarMedia(indice - 1); });
    var gNext = raiz.querySelector('[data-pa-g-next]');
    if (gNext) gNext.addEventListener('click', function () { mostrarMedia(indice + 1); });

    var visor = raiz.querySelector('[data-pa-visor]');
    if (visor) {
      var x0 = null;
      visor.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      visor.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 44) { if (dx < 0) mostrarMedia(indice + 1); else mostrarMedia(indice - 1); }
        x0 = null;
      }, { passive: true });
    }

    var lightbox = raiz.querySelector('[data-pa-lightbox]');
    var lightboxImg = raiz.querySelector('[data-pa-lightbox-img]');
    function abrirLightbox() {
      var activa = raiz.querySelector('.pa-prod__slide--activo .pa-prod__slide-img');
      if (!activa || !lightbox) return;
      lightboxImg.src = activa.getAttribute('data-pa-zoom-src') || activa.src;
      lightbox.classList.add('pa-prod__lightbox--abierto');
      lightbox.setAttribute('aria-hidden', 'false');
    }
    function cerrarLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('pa-prod__lightbox--abierto');
      lightbox.setAttribute('aria-hidden', 'true');
    }
    var zoomBtn = raiz.querySelector('[data-pa-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', abrirLightbox);
    raiz.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('pa-prod__slide-img')) abrirLightbox();
    });
    var lbCerrar = raiz.querySelector('[data-pa-lightbox-cerrar]');
    if (lbCerrar) lbCerrar.addEventListener('click', cerrarLightbox);
    if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) cerrarLightbox(); });

    var inputCant = raiz.querySelector('[data-pa-cantidad]');
    var menos = raiz.querySelector('[data-pa-menos]');
    var mas = raiz.querySelector('[data-pa-mas]');
    function ajustar(delta) {
      if (!inputCant) return;
      var v = parseInt(inputCant.value, 10) || 1;
      v = Math.max(1, v + delta);
      inputCant.value = v;
    }
    if (menos) menos.addEventListener('click', function () { ajustar(-1); });
    if (mas) mas.addEventListener('click', function () { ajustar(1); });

    var variantes = [];
    try {
      var json = raiz.querySelector('[data-pa-variantes]');
      if (json) variantes = JSON.parse(json.textContent);
    } catch (err) { variantes = []; }

    var inputId = raiz.querySelector('[data-pa-id]');
    var precioActual = raiz.querySelector('[data-pa-precio-actual]');
    var precioAntes = raiz.querySelector('[data-pa-precio-antes]');
    var barraPrecio = raiz.querySelector('[data-pa-barra-precio]');
    var agregar = raiz.querySelector('[data-pa-agregar]');
    var agregarTexto = raiz.querySelector('[data-pa-agregar-texto]');
    var barraBoton = raiz.querySelector('[data-pa-barra-agregar]');
    var barraTexto = raiz.querySelector('[data-pa-barra-texto]');
    var botonesValor = raiz.querySelectorAll('[data-pa-valor]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      var opciones = raiz.querySelectorAll('[data-pa-opcion]');
      for (var i = 0; i < opciones.length; i++) {
        var activo = opciones[i].querySelector('.pa-prod__valor--activo');
        seleccion.push(activo ? activo.getAttribute('data-pa-valor-nombre') : null);
      }
      return seleccion;
    }

    function encontrarVariante(seleccion) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var coincide = true;
        for (var j = 0; j < seleccion.length; j++) {
          if (seleccion[j] !== null && v.options[j] !== seleccion[j]) { coincide = false; break; }
        }
        if (coincide) return v;
      }
      return null;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var v = encontrarVariante(seleccion);
      if (!v) return;
      if (inputId) inputId.value = v.id;
      if (precioActual) precioActual.textContent = formatearPrecio(v.price);
      if (barraPrecio) barraPrecio.textContent = formatearPrecio(v.price);
      if (precioActual) precioActual.classList.toggle('pa-prod__precio-actual--oferta', v.compare_at_price && v.compare_at_price > v.price);
      if (precioAntes) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          precioAntes.textContent = formatearPrecio(v.compare_at_price);
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      var disp = v.available;
      if (agregar) agregar.disabled = !disp;
      if (barraBoton) barraBoton.disabled = !disp;
      if (agregarTexto) agregarTexto.textContent = disp ? 'Agregar al carrito' : 'Agotado';
      if (barraTexto) barraTexto.textContent = disp ? 'Agregar al carrito' : 'Agotado';
    }

    for (var vb = 0; vb < botonesValor.length; vb++) {
      botonesValor[vb].addEventListener('click', function () {
        var contenedor = this.closest('[data-pa-opcion]');
        var hermanos = contenedor.querySelectorAll('.pa-prod__valor');
        for (var h = 0; h < hermanos.length; h++) hermanos[h].classList.remove('pa-prod__valor--activo');
        this.classList.add('pa-prod__valor--activo');
        actualizar();
      });
    }

    var barraFija = raiz.querySelector('[data-pa-barra-fija]');
    if (barraFija && agregar) {
      var form = raiz.querySelector('#pa-form-producto');
      if (barraBoton && form) {
        barraBoton.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(agregar);
          else form.submit();
        });
      }
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (ent) {
            barraFija.classList.toggle('pa-prod__barra-fija--visible', !ent.isIntersecting && ent.boundingClientRect.top < 0);
            barraFija.setAttribute('aria-hidden', ent.isIntersecting ? 'true' : 'false');
          });
        }, { threshold: 0 });
        obs.observe(agregar);
      }
    }

    var entrega = raiz.querySelector('[data-pa-entrega]');
    if (entrega) {
      var min = parseInt(entrega.getAttribute('data-min'), 10) || 3;
      var max = parseInt(entrega.getAttribute('data-max'), 10) || 8;
      var hoy = new Date();
      function sumar(d) { var f = new Date(hoy); f.setDate(f.getDate() + d); return f; }
      function fmt(f) { return f.getDate() + ' ' + MESES[f.getMonth()]; }
      function rango(a, b) { return fmt(a) + ' - ' + fmt(b); }
      var fHoy = raiz.querySelector('[data-pa-fecha-hoy]');
      var fCamino = raiz.querySelector('[data-pa-fecha-camino]');
      var fRecibes = raiz.querySelector('[data-pa-fecha-recibes]');
      if (fHoy) fHoy.textContent = fmt(hoy);
      if (fCamino) fCamino.textContent = rango(sumar(1), sumar(2));
      if (fRecibes) fRecibes.textContent = rango(sumar(min), sumar(max));
    }

    mostrarMedia(0);
    actualizar();

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarLightbox(); });
  }

  function iniciarTodos() {
    var lista = document.querySelectorAll('[data-pa-prod]');
    for (var i = 0; i < lista.length; i++) iniciarProd(lista[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodos);
  else iniciarTodos();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pa-prod]');
    if (r) iniciarProd(r);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
